import Money from "~/models/Money";

export default class Discount {
  private readonly _description: string;
  private readonly _validity: Date | null;
  private readonly _actions: any;
  constructor({
    description,
    validity,
    actions,
  }) {
      this._description = description;
      this._validity = validity ? new Date(validity) : null;
      this._actions = actions;
  }

  get description(): string {
    return this._description;
  }

  get validity(): Date | null {
    return this._validity;
  }

  getDiscountPercentage() : number| null {
      if (!this._actions || !this._actions.percentage) {
        return null;
      }
      return this._actions.percentage * 100;
  }

  getDiscountAmount() : Money|null {
    if (!this._actions || !this._actions.amount) {
        return null;
    }
    let currency = Object.keys(this._actions.amount).find(a => !!a);
    if (currency === undefined) {
        return null;
    }
    return new Money({
      amount: this._actions.amount[currency] / 100,
      currency,
    });
  }
  isAllServices() {
    return this._actions && this._actions.orderType === 'all_services';
  }
  isForAIProofreader() {
    return this._actions && this._actions.orderType === 'ai_proofreader';
  }
  isForProofreading() {
    return this._actions && this._actions.orderType === 'proofreading_and_editing';
  }
  isForPlagiarismCheck() {
    return this._actions && this._actions.orderType === 'plagiarism_check';
  }
  isPlagiarismCoupon() {
    return this.isForPlagiarismCheck() && this._actions && this._actions.percentage === 1;
  }
}
